export const base = () => 'settings';

export const integrations = () => 'settings/integrations';

export const privacy = () => 'settings/privacy';

export const accreditationItems = () => 'settings/accreditation/items';

export const artistsItems = () => 'settings/artists/items' ;
